<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m6">
      <h5>iRecharge User</h5>
      <p class="text-justify">
        Tailored to customers that want iRecharge for their own personal use.
        Sign up and an e wallet is automatically created for you. Funds in your
        wallet can be used to pay for any of the platform products. E- Wallets
        can be funded by card, bank deposit or bank transfer and provide an
        extra mode of payment not accessible to one off users. This package is
        perfect for individuals who want to purchase airtime and pay their bills
        and subscriptions all on one platform and at their convenience.
      </p>
      <h5>Benefits</h5>
      <ul>
        <li>
          Airtime payment and bill payments from the convenience of your mobile
          device.
        </li>
        <li>Sign up and an automatic e wallet is created for you.</li>
        <li>
          Make payments from your card or e-wallet. Whichever works for you!
        </li>
        <li>You can top up and pay bills for friends and family as well.</li>
        <li>Enter parameters for multiple recharges and pay at once.</li>
        <li>
          Receive access to featured services such as iRecharge Perks and Bulk
          Sms.
        </li>
      </ul>
    </div>
    <solution-part />
  </div>
</template>
<script>
import SolutionPart from '@/components/partials/SolutionPart.vue'
export default {
  name: 'iRechargePlus',
  components: {
    SolutionPart
  },
  mounted() {
    this.startCarousel()
  },
  data() {
    return {}
  },
  methods: {
    startCarousel() {
      var owlClients = $('#owlClients')
      owlClients.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 1000,
        autoplayHoverPause: true
      })
      var owlTestimonial = $('#owlTestimonial')
      owlTestimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
      })
    }
  }
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
